import { inferBusinessDetails } from "api/businesses";
import { omniboxRequest, ScrapedData } from "api/user";
import { genericError } from "fixtures/globalConstants";
import { useMemo, useState } from "react";
import { Business } from "store/business/businessConstants";
import { isValidUrl } from "utils/urlUtils";

const useOmnibox = (props: { defaultCrawlEntireSite?: boolean } = {}) => {
  const { defaultCrawlEntireSite = true } = props;

  const [inputValue, setInputValue] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [crawlEntireSite, setCrawlEntireSite] = useState(
    defaultCrawlEntireSite
  );

  const isURLValid = useMemo(() => {
    return isValidUrl(inputValue);
  }, [inputValue]);

  const extractTopics = async (
    inputContent?: string
  ): Promise<(Business & ScrapedData) | undefined> => {
    setIsLoading(true);

    try {
      let res: ScrapedData = {};

      if (!inputContent) {
        res = await omniboxRequest({
          crawl: crawlEntireSite,
          url: inputValue,
        });
      }

      const content = inputContent || res.content;

      if (!content) {
        throw new Error("No content found");
      }

      const response = await inferBusinessDetails({
        content,
      });

      return {
        ...res,
        ...response.details,
        topics: response.topics,
      };
    } catch (error) {
      genericError(error);
    } finally {
      setIsLoading(false);
    }
  };

  return {
    crawlEntireSite,
    inputValue,
    isLoading,
    isURLValid,
    setCrawlEntireSite,
    setInputValue,
    extractTopics,
  };
};

export default useOmnibox;
